"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const events_1 = require("../../../constants/events");
const strings_1 = require("../../../constants/strings");
const conversationApprovalQuery_1 = require("../../../queries/approvals/conversationApprovalQuery");
const conversationQuery_1 = require("../../../queries/conversationQuery");
const requestListQuery_1 = require("../../../queries/requestListQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const pageLoader_1 = __importDefault(require("../../../router/loaders/pageLoader"));
const userSelectors_1 = require("../../../selectors/userSelectors");
const zustandStore_1 = require("../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../atoms/button/simpleButton"));
const simpleHeader_1 = __importDefault(require("../../organisms/header/simpleHeader"));
const actionButtonsWrapper_1 = __importDefault(require("../approvals/approvalItem/buttons/actionButtonsWrapper"));
const forwardRequestAside_1 = __importDefault(require("../approvals/asides/forwardRequestAside"));
const eventNotifier_1 = __importDefault(require("./eventNotifier"));
const requestsFooter_1 = __importDefault(require("./requestsFooter"));
const speechBubble_1 = __importDefault(require("./speechBubble"));
const lexico = new lexico_1.default();
const CreateCardAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../organisms/createCard'))));
const clonedPurchaseRequestEvents = structuredClone(events_1.events.types.purchases);
const reversedpurchasesEvents = Object.fromEntries(Object.entries(clonedPurchaseRequestEvents).map(([key, value]) => [value, key]));
const isUserAuthor = (user, event) => {
    return user?.userId === event?.author?.userId;
};
const createSimpleButton = (label, onClick, disabled, color) => {
    return (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: label, label: label, onClick: onClick, disabled: disabled, color: color });
};
function renderUiEvent({ currentUser, event, }) {
    const isCurrentUserAuthor = isUserAuthor(currentUser, event);
    const key = Number(event.sequenceNumber) + Number(event.timestamp) + Number(event.messageId);
    if (event.type === events_1.events.types.personAdded) {
        return (0, jsx_runtime_1.jsx)(eventNotifier_1.default, { event: event, isUserAuthor: isCurrentUserAuthor }, `EventNotifier-${key}`);
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(speechBubble_1.default, { event: event, isUserAuthor: isCurrentUserAuthor }) }, `Box-${key}`));
}
const getApprovalFromNewEvents = (approvalId, streamData) => {
    const approval = streamData?.events?.find((event) => event.data?.task?.state === 'ASSIGNED' && event.data?.task?.id === approvalId);
    return approval?.data?.task || null;
};
const RequestPage = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const location = (0, react_router_1.useLocation)();
    const { purchaseRequest, showNoActiveCardInfo, showConversationButtons, setShowNoActiveCardInfo, viewApprovalConversationRequestId, setShowConversationButtons, teamId, streamData, } = (0, zustandStore_1.useZustand)(state => ({
        purchaseRequest: state.request.purchaseRequest,
        showConversationButtons: state.approvals.showConversationButtons,
        showNoActiveCardInfo: state.approvals.showNoActiveCardInfo,
        setShowNoActiveCardInfo: state.setShowNoActiveCardInfo,
        viewApprovalConversationRequestId: state.approvals.viewApprovalConversationRequestId,
        teamId: state.team.team?.id,
        streamData: state.stream.streamData,
        setShowConversationButtons: state.setShowConversationButtons,
    }));
    const approvalId = initialData.approvalId || '';
    const { data: conversationApprovalFromQuery } = (0, react_query_1.useQuery)({
        ...(0, conversationApprovalQuery_1.conversationApprovalQuery)(approvalId),
        initialData: initialData.conversationApproval,
    });
    const conversationApproval = conversationApprovalFromQuery || getApprovalFromNewEvents(approvalId, streamData);
    const { requestId = conversationApproval?.request?.requestId || viewApprovalConversationRequestId || '' } = (0, react_router_1.useParams)();
    const divToScrollTo = (0, react_1.useRef)(null);
    const { data: currentUser } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.user,
    });
    const isUserCompanyOrSupportAdmin = (0, userSelectors_1.isCompanyOrSupportAdmin)(currentUser?.roles || []);
    const { data: requestData, isFetching: isGetRequestFetching } = (0, react_query_1.useQuery)({
        ...(0, requestListQuery_1.getRequestQuery)(requestId),
        initialData: initialData.requestData,
    });
    const { data: eventsData, isError: isEventsError } = (0, react_query_1.useQuery)({
        ...(0, conversationQuery_1.getEventsQuery)({
            conversationId: requestId || conversationApproval?.request.requestId || '',
            polling: false,
        }),
        initialData: initialData.eventsData,
    });
    const { data: team, isSuccess } = (0, teamQuery_1.useGetTeamQuery)({ teamId: teamId || '' });
    const cardSources = team?.sourceCards?.filter(card => card?.status === 'ACTIVE') || [];
    const { streamData: eventsStreamData } = (0, zustandStore_1.useZustand)(state => state.stream);
    const allEvents = (0, zustandStore_1.useZustand)(state => state.request.allEvents);
    const { setViewApprovalConversationRequestId, setHeaderName, setHeaderButtons, setDialog, setNotification, setPurchaseRequest, setAllEvents, setErrorMessage, setShowCreateFwdButtons, } = (0, zustandStore_1.useZustand)();
    const cancelRequest = (0, requestListQuery_1.useCancelRequestMutation)();
    const archiveRequest = (0, requestListQuery_1.useAddTagMutation)();
    const unarchiveRequest = (0, requestListQuery_1.useRemoveTagMutation)();
    const paperRef = (0, react_1.useRef)(null);
    const navigate = (0, react_router_1.useNavigate)();
    const initialRequestEvents = (0, react_1.useMemo)(() => {
        return eventsData?.events || [];
    }, [eventsData?.events]);
    const streamedRequestEvents = (0, react_1.useMemo)(() => {
        return eventsStreamData.events ? eventsStreamData.events.filter(event => event.requestId === requestId) || [] : [];
    }, [eventsStreamData.events, requestId]);
    const prevInitialRequestEvents = (0, react_use_1.usePrevious)(initialRequestEvents);
    const prevStreamedRequestEvents = (0, react_use_1.usePrevious)(streamedRequestEvents);
    const shouldRenderFooter = (0, react_1.useMemo)(() => allEvents.some(event => event.type === events_1.events.types.purchases.requestSubmitted), [allEvents]);
    const shouldShowApprovalsButtons = conversationApproval && showConversationButtons;
    (0, react_1.useEffect)(() => {
        if (location.pathname.startsWith('/approvals/') && cardSources.length === 0 && isSuccess) {
            setShowCreateFwdButtons(false);
            setShowNoActiveCardInfo(true);
        }
        else {
            setShowNoActiveCardInfo(false);
        }
    }, [isGetRequestFetching, cardSources.length, isSuccess, location.pathname]);
    (0, react_1.useEffect)(() => {
        if (isEventsError) {
            setErrorMessage({
                heading: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                    ? strings_1.errorStrings.DEFAULT
                    : lexico.trc('Heading error message', 'Something went wrong'),
                message: 'We are unable to fetch events at this time. Please try again later.',
            });
            void navigate('/error');
        }
    }, [isEventsError, navigate, setErrorMessage]);
    (0, react_1.useEffect)(() => {
        if (conversationApproval?.request.requestId &&
            conversationApproval.request.requestId !== viewApprovalConversationRequestId) {
            setViewApprovalConversationRequestId(conversationApproval.request.requestId);
            setShowConversationButtons(true);
        }
    }, [conversationApproval?.request.requestId, viewApprovalConversationRequestId]);
    (0, react_1.useEffect)(() => {
        if (location.pathname.startsWith('/requests/')) {
            if (requestData.state === 'APPROVED' ||
                requestData.state === 'REJECTED' ||
                (requestData.state === 'SUBMITTED' && purchaseRequest.state === 'APPROVED')) {
                setHeaderButtons([
                    () => createSimpleButton(requestData.isArchived ? lexico.trc('Button', 'UNARCHIVE') : lexico.trc('Button', 'ARCHIVE'), () => requestData.isArchived
                        ? unarchiveRequest.mutate({ requestId: requestId || '', tag: 'archived' }, {
                            onSuccess: () => {
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.SUCCESS,
                                        message: lexico.trc('Success message', 'Request unarchived.'),
                                    },
                                ]);
                            },
                        })
                        : archiveRequest.mutate({ requestId: requestId || '', tag: 'archived' }, {
                            onSuccess: () => {
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.SUCCESS,
                                        message: lexico.trc('Success message', 'Request archived.'),
                                    },
                                ]);
                            },
                        }), false, 'secondary'),
                ]);
            }
            else if (requestData.state === 'CREATED' ||
                (requestData.state === 'SUBMITTED' && purchaseRequest.state !== 'APPROVED')) {
                setHeaderButtons([
                    () => createSimpleButton(lexico.trc('Button', 'Cancel Request'), () => setDialog({
                        message: lexico.trc('Warning message', 'Are you sure you want to cancel this request?'),
                        type: strings_1.notificationStrings.WARNING,
                        open: true,
                        actionText: lexico.trc('Button', "I'm sure"),
                        showCancel: true,
                        cancelText: lexico.trc('Button', "Don't cancel"),
                        onAccept: () => cancelRequest.mutate({ requestId: requestId || '' }, {
                            onSuccess: () => {
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.SUCCESS,
                                        message: lexico.trc('Success message', 'Request cancelled.'),
                                        onClose: () => {
                                            // here we need refresh be does not send updated data
                                            globalThis.location.pathname = isUserCompanyOrSupportAdmin
                                                ? '/wallet'
                                                : '/wallet/my-cards';
                                        },
                                    },
                                ]);
                            },
                            onError: () => {
                                lexico.trc('Warning message', 'We are unable to cancel the request at this time. ' + 'Please try again later.');
                            },
                        }),
                    }), false, 'secondary'),
                ]);
            }
        }
        else {
            setHeaderButtons([]);
        }
        return () => {
            setHeaderButtons([]);
        };
    }, [requestData.isArchived, requestData.state, location.pathname, requestId, purchaseRequest, currentUser?.roles]);
    (0, react_1.useEffect)(() => {
        if (!lodash_1.default.isEmpty(requestData)) {
            setHeaderName(requestData.title || lexico.tr('New request'));
            setPurchaseRequest(requestData);
        }
        return () => {
            setHeaderName('');
        };
    }, [requestData]);
    (0, react_1.useEffect)(() => {
        if (!lodash_1.default.isEqual(initialRequestEvents, prevInitialRequestEvents) ||
            !lodash_1.default.isEqual(streamedRequestEvents, prevStreamedRequestEvents)) {
            setAllEvents(streamedRequestEvents.length > 0
                ? lodash_1.default.uniqBy([...initialRequestEvents, ...streamedRequestEvents], 'messageId')
                : [...initialRequestEvents]);
        }
    }, [initialRequestEvents, prevInitialRequestEvents, prevStreamedRequestEvents, streamedRequestEvents]);
    (0, react_1.useEffect)(() => {
        if (purchaseRequest) {
            const newEventForRequestDetail = allEvents?.findLast(event => event.requestId === purchaseRequest.requestId && reversedpurchasesEvents[event.type]);
            if (newEventForRequestDetail &&
                newEventForRequestDetail.data.task?.request.state &&
                newEventForRequestDetail.data.task.request.state !== purchaseRequest.state) {
                setPurchaseRequest({
                    ...purchaseRequest,
                    state: newEventForRequestDetail.data.task.request.state,
                });
            }
        }
    }, [allEvents, purchaseRequest]);
    (0, react_1.useEffect)(() => {
        if (allEvents.length > 0) {
            divToScrollTo.current?.scrollIntoView({
                behavior: 'auto',
                block: 'end',
            });
        }
    }, [allEvents.length]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, { children: shouldShowApprovalsButtons && ((0, jsx_runtime_1.jsx)(actionButtonsWrapper_1.default, { customStyle: {
                                marginLeft: 'auto',
                            }, shouldShowViewConversationButton: false, approvalItem: conversationApproval })) }), showNoActiveCardInfo && ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Alert, { sx: { width: '100%' }, "data-testid": "card-status-alert", severity: "warning", children: lexico.trc('Warning message', 'There are no active cards for this team') }) })), (0, jsx_runtime_1.jsx)(material_1.Paper, { "ts-variant": "container", ref: paperRef, style: { overflowY: 'auto' }, children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 1, children: [allEvents.map(event => event.type !== events_1.events.types.purchases.approvalTask &&
                                    event.type !== events_1.events.types.dataEvent &&
                                    renderUiEvent({ currentUser, event, allEvents })), (0, jsx_runtime_1.jsx)("div", { style: { marginTop: '20px' }, ref: divToScrollTo })] }) }), shouldRenderFooter && (0, jsx_runtime_1.jsx)(requestsFooter_1.default, {}), (0, jsx_runtime_1.jsx)(forwardRequestAside_1.default, {})] }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(CreateCardAside, {}) })] }));
};
exports.default = RequestPage;
